import React, { FunctionComponent } from 'react';

import './Modal.scss';
import { classHandler } from '../../utils';
import { useSelector } from 'react-redux';
import { getApplicationModeState } from '../../selectors';

type ModalProps = {
  isVisible: boolean;
  width: string;
  className?: string;
  overlayClassName?: string;
  height: string;
  handleClose: any;
};

export const Modal: FunctionComponent<ModalProps> = ({
  isVisible,
  width,
  height,
  className,
  overlayClassName,
  children,
  handleClose,
}) => {
  const applicationMode = useSelector(getApplicationModeState);

  if (!isVisible) return null;

  const overlayClass = overlayClassName ? `Modal__overlay ${overlayClassName}` : 'Modal__overlay';

  const handleCloseClick = (event: any) => {
    if (event.target.className === overlayClass) {
      handleClose(false);
    }
  };

  return (
    <div className={overlayClass} onClick={handleCloseClick}>
      <div
        style={{ width, height }}
        className={classHandler('Modal', applicationMode, undefined, undefined, className)}
      >
        {children}
      </div>
    </div>
  );
};
